(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("customPropTypes", [], factory);
	else if(typeof exports === 'object')
		exports["customPropTypes"] = factory();
	else
		root["customPropTypes"] = factory();
})(this, function() {
return 